import { render, staticRenderFns } from "./Command.vue?vue&type=template&id=2cfef66c&scoped=true&"
import script from "./Command.vue?vue&type=script&lang=js&"
export * from "./Command.vue?vue&type=script&lang=js&"
import style0 from "./Command.vue?vue&type=style&index=0&id=2cfef66c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfef66c",
  null
  
)

export default component.exports